import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';

@Component({
  selector: 'vc-auth-button',
  templateUrl: './auth-button.component.html',
  styleUrls: ['./auth-button.component.scss']
})
export class AuthButtonComponent {
  @Input() type: string;

  constructor(public dialog: MatDialog) {}

  openDialog() {
    const config: any = {
      disableClose: false,
      maxWidth: 1280,
      ariaLabelledBy: 'acc-dialogHeading',
      role: 'dialog',
      data: {
        type: this.type,
        forced: false
      }
    };
    this.dialog.open(AuthModalComponent, config);
  }
}
